import { defineComponent as o, createBlock as t, openBlock as n, unref as r, mergeProps as l, withCtx as p, createElementVNode as m } from "vue";
import { RevIcon as u } from "@ds/components/Icon";
const s = /* @__PURE__ */ o({
  name: "IconTouch",
  __name: "IconTouch",
  props: {
    size: {},
    alternativeText: {}
  },
  setup(c) {
    const a = c;
    return (i, e) => (n(), t(r(u), l(a, { "view-box": "0 0 24 24" }), {
      default: p(() => [...e[0] || (e[0] = [
        m("path", {
          "fill-rule": "evenodd",
          d: "M11.193 4.604c0-.71-.242-1.31-.666-1.733A2.133 2.133 0 0 0 9.016 2.25a2.132 2.132 0 0 0-1.51.62C7.08 3.296 6.84 3.896 6.84 4.605v6.166L4.851 13.42c-.397.53-.59 1.232-.6 1.886-.011.648.156 1.387.647 1.923a.772.772 0 0 0 .023.023l3.554 3.553c.46.497 1.137.944 1.968.944h4.278a5.695 5.695 0 0 0 2.76-.701 4.673 4.673 0 0 0 1.541-1.355 3.85 3.85 0 0 0 .728-2.258V11.02c0-.71-.241-1.31-.666-1.734a2.133 2.133 0 0 0-1.51-.62 2.166 2.166 0 0 0-.785.147 2.218 2.218 0 0 0-.557-.952 2.133 2.133 0 0 0-1.51-.62 2.137 2.137 0 0 0-1.427.54 2.136 2.136 0 0 0-1.426-.54 2.169 2.169 0 0 0-.676.107V4.604m6.493 14.357c.363-.453.564-.984.564-1.525V11.02c0-.36-.116-.562-.226-.673a.633.633 0 0 0-.45-.181.634.634 0 0 0-.45.181c-.111.11-.226.313-.226.673v.713a.75.75 0 0 1-1.5 0V9.594c0-.36-.116-.562-.226-.672a.633.633 0 0 0-.45-.182.633.633 0 0 0-.45.182c-.111.11-.227.312-.227.672v1.426a.75.75 0 0 1-1.5 0V9.594c0-.36-.115-.562-.226-.672a.633.633 0 0 0-.45-.182.633.633 0 0 0-.45.182c-.11.11-.226.312-.226.67v1.428a.75.75 0 0 1-1.5 0V4.604c0-.36-.116-.562-.227-.672a.633.633 0 0 0-.45-.182.632.632 0 0 0-.45.181C8.456 4.041 8.34 4.244 8.34 4.604v9.98a.75.75 0 1 1-1.5 0V13.27l-.789 1.052c-.168.225-.294.601-.3 1.01-.008.408.103.714.244.875l3.552 3.55a.795.795 0 0 1 .023.025c.29.316.6.469.873.469h4.278a4.135 4.135 0 0 0 1.977-.476 3.232 3.232 0 0 0 .988-.813",
          "clip-rule": "evenodd"
        }, null, -1)
      ])]),
      _: 1
    }, 16));
  }
});
export {
  s as default
};
